exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div#container-banner{padding:140px 0}a.text-act-car{color:#fff;text-shadow:2px 0 0 #160101;text-transform:uppercase}", ""]);

// exports
